import { createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { AuthState } from '@core/models/types/store.model';

const initialState: AuthState = {
  credential: undefined,
  userName: '',
  permissions: [],
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.login, (state, data) => ({ ...state, userName: data.body.userName })),
  on(AuthActions.loginSuccess, (state, data) => ({
    ...state,
    credential: data.response,
    userName: data.userName
  })),
  on(AuthActions.logout, () => {
    return { ...initialState, permissions: [] };
  }),
  on(AuthActions.refreshTokenSuccess, (state, data) => ({...state, credential: data.response})),
  on(AuthActions.loadPermissionsSuccess, (state, data) => ({...state, permissions: data.permissions}))
);
